<div class="confirmation-backdrop">
  <div
    class="confirmation-dialog"
    [ngClass]="{
      'compact-dialog': isDefault || isCustomMsg,
      'full-dialog': !isDefault && !isCustomMsg
    }"
  >
    @if (showClose) {
    <app-button
      class="close-btn"
      variation="link"
      [hasIcon]="true"
      iconClassName="cm-icons-close"
      text=""
      ariaLabel="Close"
      automationAttribute="close-dialog-btn"
      (clickEvent)="onClose()"
    ></app-button>
    }
    <div class="dialog-header">
      @if (isDefault) {
      <h2 class="headline">
        {{ (headerTitle$ | async) ?? "" }} {{ (headerName$ | async) ?? "" }}
      </h2>
      } @else {
      <h2 class="headline">
        {{ (headerTitle$ | async) ?? "" }}
      </h2>
      }
      <div class="headline-underline"></div>
    </div>
    <div class="dialog-body">
      @if (isDefault) {
      <div class="sub-headline">
        {{ "lbl_confirm_prefix" | content }} {{ (message$ | async) ?? "" }}
        {{ (headerTitle$ | async) ?? "" | lowercase }} this
        {{ headerName$ | async }},
        {{ "lbl_confirm_suffix" | content }}
      </div>
      } @else if (isCustomMsg) {
      <div class="sub-headline">{{ content }}</div>
      } @else if (!isDefault && !isCustomMsg) {
      <div class="sub-headline" [innerHTML]="(content$ | async) ?? ''"></div>
      }
    </div>
    <div class="dialog-footer">
      <div class="confirmation-actions">
        <app-button
          [text]="(confirmText$ | async) ?? 'lbl_confirm'"
          color="primary"
          iconClassName="cm-icons-angle-right"
          [hasIcon]="true"
          [automationAttribute]="'lbl_confirm'"
          (clickEvent)="onConfirm()"
        />
        <app-button
          [text]="(cancelText$ | async) ?? 'lbl_cancel_btn'"
          variation="link"
          className="link-underline"
          [automationAttribute]="'cancel-btn'"
          (clickEvent)="onCancel()"
        />
      </div>
    </div>
  </div>
</div>
